// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrendingVideos_trendingSection__K\\+xFk {
    color: white;
    min-height: 100%;
    background-color: transparent;
    width: 100%;
    max-width: 95%;
    margin: 0 auto;
  }
  
  .TrendingVideos_trendingHeader__jLGIS {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .TrendingVideos_title__actKa {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
  }
  
  .TrendingVideos_navigationButtons__wSSLX {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  
  .TrendingVideos_navigationLine__xm8lW {
    width: 20px;
    height: 2px;
    background-color: #ff0000;
  }
  
  .TrendingVideos_navButton__5X9p4 {
    background: #2a2a2a;
    border: none;
    border-radius: 8px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: white;
    transition: all 0.3s ease;
  }
  
  .TrendingVideos_navButton__5X9p4:hover {
    background: #3a3a3a;
  }
  
  .TrendingVideos_navButton__5X9p4:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .TrendingVideos_swiperContainer__Ccrcv {
    margin: 0 auto;
    padding: 0;
    position: relative;
  }
  
  .TrendingVideos_swiperWrapper__ifsW0 {
    width: 100%;
  }
  
  .TrendingVideos_swiperSlide__fTE0w {
    height: auto;
  }
  
  .TrendingVideos_mediaCard__-8p59 {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    background: #2a2a2a;
    height: 100%;
    transition: transform 0.3s ease;
  }
  
  .TrendingVideos_mediaCard__-8p59:hover {
    transform: translateY(-5px);
  }
  
  .TrendingVideos_imageWrapper__JrP04 {
    position: relative;
    width: 100%;
    padding-top: 56.25%; /* 16:9 aspect ratio */
    overflow: hidden;
  }
  
  .TrendingVideos_mediaImage__q9w9r {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .TrendingVideos_overlay__YoYXm {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.8));
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 15px;
  }
  
  .TrendingVideos_mediaLabel__Pc0Af {
    display: flex;
    justify-content: flex-start;
  }
  
  .TrendingVideos_labelText__jxA5f {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    color: white;
  }
  
  .TrendingVideos_redDot__fQZZh {
    width: 6px;
    height: 6px;
    background-color: #ff0000;
    border-radius: 50%;
  }
  
  .TrendingVideos_playButton__Q8WN6 {
    position: absolute;
    right: 15px;
    bottom: 15px;
    background: #ff0000;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .TrendingVideos_playButton__Q8WN6:hover {
    transform: scale(1.1);
  }
  
  .TrendingVideos_mediaContent__1c5jc {
    padding: 20px;
  }
  
  .TrendingVideos_mediaTitle__jUUMv {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 10px 0;
    color: white;
  }
  
  .TrendingVideos_mediaDescription__ejp6o {
    font-size: 14px;
    color: #a0a0a0;
    margin: 0 0 15px 0;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  
  .TrendingVideos_watchNowButton__s9hti {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #ff0000;
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    color: white;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .TrendingVideos_watchNowButton__s9hti:hover {
    background: #cc0000;
  }
  
  @media (max-width: 1024px) {
    .TrendingVideos_title__actKa {
      font-size: 24px;
    }
  }
  
  @media (max-width: 768px) {
    .TrendingVideos_trendingHeader__jLGIS {
      margin-bottom: 15px;
    }
  
    .TrendingVideos_navButton__5X9p4 {
      width: 36px;
      height: 36px;
    }
  }
  
  @media (max-width: 480px) {
    .TrendingVideos_title__actKa {
      font-size: 18px;
    }
    .TrendingVideos_mediaCard__-8p59:hover {
      transform: translateY(0px);
    }
    .TrendingVideos_playButton__Q8WN6:hover {
      transform: none;
    }
    
  
    .TrendingVideos_mediaTitle__jUUMv {
      font-size: 16px;
    }
    
    .TrendingVideos_mediaDescription__ejp6o {
      font-size: 13px;
    }
    .TrendingVideos_trendingSection__K\\+xFk{
      padding: 0;
    }
    .TrendingVideos_trendingHeader__jLGIS{
      margin-bottom: 5px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Homepage/components/Css/TrendingVideos.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,WAAW;IACX,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB,EAAE,sBAAsB;IAC3C,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,wEAAwE;IACxE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,YAAY;EACd;;EAEA;IACE,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE;MACE,eAAe;IACjB;IACA;MACE,0BAA0B;IAC5B;IACA;MACE,eAAe;IACjB;;;IAGA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;IACA;MACE,UAAU;IACZ;IACA;MACE,kBAAkB;IACpB;EACF","sourcesContent":[".trendingSection {\n    color: white;\n    min-height: 100%;\n    background-color: transparent;\n    width: 100%;\n    max-width: 95%;\n    margin: 0 auto;\n  }\n  \n  .trendingHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  .title {\n    font-size: 20px;\n    font-weight: bold;\n    margin: 0;\n  }\n  \n  .navigationButtons {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n  }\n  \n  .navigationLine {\n    width: 20px;\n    height: 2px;\n    background-color: #ff0000;\n  }\n  \n  .navButton {\n    background: #2a2a2a;\n    border: none;\n    border-radius: 8px;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: white;\n    transition: all 0.3s ease;\n  }\n  \n  .navButton:hover {\n    background: #3a3a3a;\n  }\n  \n  .navButton:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  \n  .swiperContainer {\n    margin: 0 auto;\n    padding: 0;\n    position: relative;\n  }\n  \n  .swiperWrapper {\n    width: 100%;\n  }\n  \n  .swiperSlide {\n    height: auto;\n  }\n  \n  .mediaCard {\n    position: relative;\n    border-radius: 12px;\n    overflow: hidden;\n    background: #2a2a2a;\n    height: 100%;\n    transition: transform 0.3s ease;\n  }\n  \n  .mediaCard:hover {\n    transform: translateY(-5px);\n  }\n  \n  .imageWrapper {\n    position: relative;\n    width: 100%;\n    padding-top: 56.25%; /* 16:9 aspect ratio */\n    overflow: hidden;\n  }\n  \n  .mediaImage {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.8));\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 15px;\n  }\n  \n  .mediaLabel {\n    display: flex;\n    justify-content: flex-start;\n  }\n  \n  .labelText {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 12px;\n    color: white;\n  }\n  \n  .redDot {\n    width: 6px;\n    height: 6px;\n    background-color: #ff0000;\n    border-radius: 50%;\n  }\n  \n  .playButton {\n    position: absolute;\n    right: 15px;\n    bottom: 15px;\n    background: #ff0000;\n    border: none;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.3s ease;\n  }\n  \n  .playButton:hover {\n    transform: scale(1.1);\n  }\n  \n  .mediaContent {\n    padding: 20px;\n  }\n  \n  .mediaTitle {\n    font-size: 18px;\n    font-weight: 600;\n    margin: 0 0 10px 0;\n    color: white;\n  }\n  \n  .mediaDescription {\n    font-size: 14px;\n    color: #a0a0a0;\n    margin: 0 0 15px 0;\n    line-height: 1.4;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n  \n  .watchNowButton {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: #ff0000;\n    border: none;\n    border-radius: 6px;\n    padding: 8px 16px;\n    color: white;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n  }\n  \n  .watchNowButton:hover {\n    background: #cc0000;\n  }\n  \n  @media (max-width: 1024px) {\n    .title {\n      font-size: 24px;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .trendingHeader {\n      margin-bottom: 15px;\n    }\n  \n    .navButton {\n      width: 36px;\n      height: 36px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .title {\n      font-size: 18px;\n    }\n    .mediaCard:hover {\n      transform: translateY(0px);\n    }\n    .playButton:hover {\n      transform: none;\n    }\n    \n  \n    .mediaTitle {\n      font-size: 16px;\n    }\n    \n    .mediaDescription {\n      font-size: 13px;\n    }\n    .trendingSection{\n      padding: 0;\n    }\n    .trendingHeader{\n      margin-bottom: 5px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trendingSection": `TrendingVideos_trendingSection__K+xFk`,
	"trendingHeader": `TrendingVideos_trendingHeader__jLGIS`,
	"title": `TrendingVideos_title__actKa`,
	"navigationButtons": `TrendingVideos_navigationButtons__wSSLX`,
	"navigationLine": `TrendingVideos_navigationLine__xm8lW`,
	"navButton": `TrendingVideos_navButton__5X9p4`,
	"swiperContainer": `TrendingVideos_swiperContainer__Ccrcv`,
	"swiperWrapper": `TrendingVideos_swiperWrapper__ifsW0`,
	"swiperSlide": `TrendingVideos_swiperSlide__fTE0w`,
	"mediaCard": `TrendingVideos_mediaCard__-8p59`,
	"imageWrapper": `TrendingVideos_imageWrapper__JrP04`,
	"mediaImage": `TrendingVideos_mediaImage__q9w9r`,
	"overlay": `TrendingVideos_overlay__YoYXm`,
	"mediaLabel": `TrendingVideos_mediaLabel__Pc0Af`,
	"labelText": `TrendingVideos_labelText__jxA5f`,
	"redDot": `TrendingVideos_redDot__fQZZh`,
	"playButton": `TrendingVideos_playButton__Q8WN6`,
	"mediaContent": `TrendingVideos_mediaContent__1c5jc`,
	"mediaTitle": `TrendingVideos_mediaTitle__jUUMv`,
	"mediaDescription": `TrendingVideos_mediaDescription__ejp6o`,
	"watchNowButton": `TrendingVideos_watchNowButton__s9hti`
};
export default ___CSS_LOADER_EXPORT___;
